module.exports = __webpack_public_path__ + "media/images/greennote 9-34852f0702395aaa2cbe896032bd703a.svg";